// extracted by mini-css-extract-plugin
export default {"root":"SectionFaqs_root__oUzIA"};